export default __webpack_public_path__ + "static/media/home-dentist-parallax-bg.1db2d64e.jpg";